/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UserControllerPermissionViewModel } from "../types/UserControllerPermissionViewModel.ts";

export const userControllerPermissionViewModelSchema = z.object({
  userId: z.optional(
    z
      .number()
      .int()
      .describe("ID do usuário ao qual a permissão será atribuída."),
  ),
  controllerId: z.optional(
    z
      .number()
      .int()
      .describe("ID do controller ao qual a permissão se aplica."),
  ),
  canRead: z.optional(
    z
      .boolean()
      .describe(
        "Define se o usuário possui permissão de leitura neste controller.",
      ),
  ),
  canCreate: z.optional(
    z
      .boolean()
      .describe(
        "Define se o usuário possui permissão de criação neste controller.",
      ),
  ),
  canUpdate: z.optional(
    z
      .boolean()
      .describe(
        "Define se o usuário possui permissão de edição neste controller.",
      ),
  ),
  canDelete: z.optional(
    z
      .boolean()
      .describe(
        "Define se o usuário possui permissão de exclusão neste controller.",
      ),
  ),
}) as unknown as ToZod<UserControllerPermissionViewModel>;
